import {
    UnorderedListOutlined, ShopOutlined, HomeOutlined, SolutionOutlined, ExperimentOutlined, AuditOutlined
} from '@ant-design/icons';
import { Dropdown, Menu } from 'antd';
import React from 'react';
import { withRouter } from '../../utils/router'
import UserMenu from './UserMenu'

class ContentHeader extends React.Component {
    state = {
        displayMenuHorizontalMode: "block",
        displayMenuDropdownMode: "none",
        currentKey: "0",
    }

    getPage(path) {
        if (path.startsWith('/solution')) {
            return '1';
        } else if (path.startsWith('/template')) {
            return '2';
        } else if (path.startsWith('/library')) {
            return '3';
        } else if (path.startsWith('/tutorial')) {
            return '4';
        } else {
            return '0';
        }
    }

    componentDidMount() {
        window.addEventListener('resize', this.resize);
        this.resize();
        this.setState({ currentKey: this.getPage(this.props.router.location.pathname) });
    }

    constructor(props) {
        super(props);
        this.resize = this.resize.bind(this);
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.resize);
    }

    componentDidUpdate(prevProps) {
        if (prevProps.router.location.pathname !== this.props.router.location.pathname) {
            this.setState({ currentKey: this.getPage(this.props.router.location.pathname) });
        }
    }

    resize() {
        if (window.outerWidth <= 680) {
            this.setState({ displayMenuHorizontalMode: "none" });
            this.setState({ displayMenuDropdownMode: "block" });
        } else {
            this.setState({ displayMenuHorizontalMode: "block" });
            this.setState({ displayMenuDropdownMode: "none" });
        }
    }

    render() {
        let defaultPageKey = this.getPage(this.props.router.location.pathname);

        const items = [
            {
                label: <a href="/"><HomeOutlined />&nbsp;主页</a>,
                key: '0',
            },
            {
                label: <a href="/solution"><SolutionOutlined />&nbsp;解决方案</a>,
                key: '1',
            },
            {
                label: <a href="/template"><ShopOutlined />&nbsp;模板库</a>,
                key: '2',
            },
            {
                label: <a href="/library"><ExperimentOutlined />&nbsp;素材库</a>,
                key: '3',
            },
            {
                label: <a href="/tutorial"><AuditOutlined />&nbsp;入门教程</a>,
                key: '4',
            }
        ]

        const menu = (
            <Menu className='menu'
                theme="light"
                mode="horizontal"
                defaultSelectedKeys={[defaultPageKey]}
                selectedKeys={[this.state.currentKey]}
                style={{ lineHeight: '50px', border: 'none' }} items={items}>
            </Menu>
        );
        return (
            <div id='headerbar' style={{ display: "flex", alignItems: "center" }}>
                <div style={{ lineHeight: '64px', float: 'left', display: this.state.displayMenuDropdownMode }}>
                    <Dropdown menu={{ items }}>
                        <UnorderedListOutlined style={{ verticalAlign: "middle", color: "#3f3ea3", fontSize: "20px" }} />
                    </Dropdown>
                </div>
                <div style={styles.logo} onClick={() => this.props.router.navigate('/')}>
                    <img style={styles.img} src={'/logo.png'} alt="" />
                    <span style={styles.text}>元纹</span>
                </div>
                <div style={{ flexGrow: '1', overflow: "hidden", whiteSpace: "nowrap" }}>
                    <div style={{ display: this.state.displayMenuHorizontalMode }}>
                        {menu}
                    </div>
                </div>
                <div style={{ width: "60px", flexGrow: '0', lineHeight: '64px', textAlign: 'right' }}>
                    <UserMenu />
                </div>
            </div >
        )
    }
}

const styles = {
    logo: {
        height: '50px',
        width: '150px',
        flexGrow: '0',
        padding: '4px',
        fontWeight: 'bolder',
        fontSize: 'large',
        textAlign: 'left',
        cursor: 'pointer',
        float: 'left',
    },
    img: {
        margin: '0 5px 0 0',
        height: '40px',
        width: '40px',
    },
    text: {
        fontSize: '25px',
        color: '#55cd53',
        lineHeight: '40px',
        verticalAlign: 'top',
    }
}

export default withRouter(ContentHeader)